package ext

import kotlin.math.pow
import kotlin.math.round

fun Double.toFixed(s : Int): Double {
    if (s==0) return round(this)
    val power = (10.0).pow(s)
    return round(this * power)/power
}
